import { createSlice } from '@reduxjs/toolkit'

const initialState = {
   isAuthenticated: false,
   privateKey: null,
   publicKey: null,
   privateKeyEncrypted: null,
   settings: {
      askPasswordOnTxn: false,
      autoSessionTimeout: false,
   },
}

export const userSlice = createSlice({
   name: 'user',
   initialState,
   reducers: {
      setPublicKey: (state, action) => {
         state.publicKey = action.payload
      },
      setPrivateKey: (state, action) => {
         state.privateKey = action.payload
      },
      setPrivateKeyEncrypted: (state, action) => {
         state.privateKeyEncrypted = action.payload
      },
      login: (state, action) => {
         state.isAuthenticated = true
         state.privateKey = action.payload.privateKey
         state.privateKeyEncrypted = action.payload.privateKeyEncrypted
         state.publicKey = action.payload.publicKey
      },
      logout: state => {
         state.isAuthenticated = false
         state.privateKey = null
         state.publicKey = null
      },
      updateSetting: (state, action) => {
         state.settings[action.payload.setting] =
            !state.settings[action.payload.setting]
      },
   },
})

export const {
   login,
   logout,
   updateSetting,
   setPrivateKey,
   setPrivateKeyEncrypted,
   setPublicKey,
} = userSlice.actions

export default userSlice.reducer
